import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import GalleryPreview from './components/GalleryPreview';
import GalleryPage from './components/GalleryPage';
import Blog from './components/Blog';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    window.location.hash === '#gallery' ? 'gallery' : 'home'
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(window.location.hash === '#gallery' ? 'gallery' : 'home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const openGallery = () => {
    window.location.hash = 'gallery';
    setCurrentPage('gallery');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const returnHome = () => {
    window.location.hash = '';
    setCurrentPage('home');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    if (currentPage !== 'home') {
      window.location.hash = '';
      setCurrentPage('home');
      window.setTimeout(() => scrollToSection(sectionId), 80);
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <Header 
        isScrolled={isScrolled} 
        scrollToSection={scrollToSection}
        openGallery={openGallery}
      />
      {currentPage === 'gallery' ? (
        <>
          <GalleryPage returnHome={returnHome} />
          <Footer />
        </>
      ) : (
        <>
          <Hero scrollToSection={scrollToSection} />
          <About />
          <Products />
          <GalleryPreview openGallery={openGallery} />
          <Blog />
          <WhyChooseUs />
          <Contact />
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
